<ng-container *transloco="let t">
  <div
    class="max-w-144 rounded-3 bg-grey-50 px-lg py-lg shadow-1 md:py-xl"
    [class.cursor-pointer]="priceRange?.percentageBreakdown"
    (click)="toggleShowBreakdown()"
    data-testid="card"
  >
    <div class="flex justify-start">
      @if (offering.icon) {
        <div class="text-xl md:text-3xl">
          <cft-dynamic-icon [icon]="offering.icon"></cft-dynamic-icon>
        </div>
      }
      <div class="w-full" [class.ml-lg]="offering.icon">
        <div class="flex justify-between font-semibold">
          <div class="text-sm md:text-md">
            @if (numberOfItems) {
              {{ numberOfItems }} x
            }
            {{ offering.label }}
          </div>
          @if (editLink) {
            <a [routerLink]="editLink" class="cursor-pointer" queryParamsHandling="merge">
              <fa-icon [icon]="editIcon"></fa-icon>
            </a>
          }
        </div>
        <div class="mt-xs">
          <div class="text-sm text-green-700">
            <fa-icon [icon]="completedIcon"></fa-icon>
            {{ t('createJobRequest.priceRange.detailsCompleted') }}
          </div>
          @if (priceRange && priceRange.fromAmount && priceRange.toAmount) {
            <cft-chip class="mt-2xs" colour="purple">
              {{ priceRange.fromAmount | bgoRappenToFranc | currency: 'CHF' : 'code' : '2.0-0' }}
              {{ t('createJobRequest.priceRange.priceTo') }}
              {{ priceRange.toAmount | bgoRappenToFranc | currency: 'CHF' : '' : '2.0-0' }}
            </cft-chip>
          } @else if (priceRange && priceRange.freeOfCharge) {
            <cft-chip class="mt-2xs" colour="green">
              {{ t('createJobRequest.priceRange.free') }}
            </cft-chip>
          } @else if (offering.type === OfferingType.MinimumPrice && offering.fromPrice) {
            <cft-chip class="mt-2xs" colour="purple">
              {{ t('createJobRequest.minimumPrice.fromPrice', {fromPrice: offering.fromPrice | bgoRappenToFranc}) }}
            </cft-chip>
          }
        </div>
        @if (priceRange?.containUnknowns) {
          <cft-price-range-info
            [infoText]="
              priceRange?.fromAmount
                ? t('createJobRequest.priceRange.containUnknownsTextClient')
                : t('createJobRequest.priceRange.priceIncalculableHint')
            "
            class="mt-xs"
          ></cft-price-range-info>
        }
        @if (showBreakdown && priceRange && priceRange.percentageBreakdown.serviceCosts) {
          <cft-price-breakdown [breakdown]="priceRange.percentageBreakdown" class="mt-xl"></cft-price-breakdown>
        }
      </div>
    </div>
  </div>
</ng-container>
